import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Headline from '@components/atoms/headline/headline';
import Copy from '@components/atoms/copy/copy';
import { getColor, getSpace, mq, px2rem } from '@stylesheets/tools';

import Card from './Card';

const StyledIntroCard = styled(Card)`
  h2 {
    font-size: ${px2rem('18px')};
    color: ${getColor('black')};

    ${mq('m')} {
      font-size: ${px2rem('24px')};
    }
  }

  p {
    margin: 0;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 4; /* number of lines to show */
    line-clamp: 4;
    -webkit-box-orient: vertical;
    display: -webkit-box;
    text-overflow: ellipsis;
  }
`;

const VideoWrapper = styled.div`
  position: relative;
  width: 100%;
  margin-bottom: ${getSpace('xxxs')};

  aspect-ratio: 3 / 2;

  &:after {
    position: absolute;
    top: -12px;
    right: -12px;
    width: 24px;
    height: 24px;
    background: ${getColor('white')};
    content: '';
    transform: rotate(45deg);

    ${mq('m')} {
      top: -10px;
      right: -10px;
      width: 20px;
      height: 20px;
    }
  }

  ${mq('m')} {
    aspect-ratio: 16 / 6;
  }

  video {
    object-fit: fill;
    width: 100%;
    height: 100%;
    display: block;
    position: relative;
    z-index: -1; // iOS fix
  }

  h3 {
    color: ${getColor('black')} !important;
    padding: 0 ${getSpace('s')};
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 100%;
    pointer-events: none;
    margin: 0 !important;
    font-size: ${px2rem('25px')};

    ${mq('m')} {
      font-size: ${px2rem('40px')};
    }
  }
`;

const IntroCard = ({ headline, copy, subline }) => {
  return (
    <StyledIntroCard>
      <VideoWrapper>
        <video
          poster="/static/images/video-poster/transition-video-poster.jpg"
          autoPlay
          muted
          playsInline
          loop
        >
          <source
            src="/static/video/archive-transition/futurium-archive-background-square-v2.mp4"
            type="video/mp4"
            media="all and (max-width: 768px)"
          />

          <source
            src="/static/video/archive-transition/futurium-archive-background-v2.mp4"
            type="video/mp4"
          />
        </video>

        <Headline tag="h3" primary>
          {headline}
        </Headline>
      </VideoWrapper>
      <Headline>{subline}</Headline>
      <Copy small>{copy}</Copy>{' '}
    </StyledIntroCard>
  );
};

IntroCard.propTypes = {
  headline: PropTypes.string.isRequired,
  subline: PropTypes.string.isRequired,
  copy: PropTypes.string.isRequired
};

export default IntroCard;
